// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingScreen_container__TovQH","backgroundImage":"LoadingScreen_backgroundImage__2AjZP"};